import axios from 'axios';
import { useConfig } from '../config';
import { MetaContainer } from '../state/meta';
import { generateUUID } from '../components/utils';

type EventType = 'purchase' | 'addtocart' | 'click';

type Loop54EventPayload = {
	events: {
		type: EventType;
		entity: {
			type: 'Product';
			id: string;
			attributes?: Record<any, any>;
		};
	}[];
};

export function useLoop54Events() {
	const { loop54Api } = useConfig();
	const { searchProfileId, randomizeSearchProfileId } = MetaContainer.useContainer();
	const loop54PostHeaders = {
		'Api-Version': 'V3',
		'User-id': randomizeSearchProfileId ? generateUUID() : searchProfileId,
	};
	function sendLoop54Event(payload: Loop54EventPayload) {
		axios.post(loop54Api + 'createEvents', payload, {
			withCredentials: false,
			headers: loop54PostHeaders,
		});
	}

	return { sendLoop54Event };
}
